import LocationsChicago from '@/components/Pages/Home Page/Locations/LocationsChicago.vue';
import LocationsDirectory from '@/components/Pages/Home Page/Locations/LocationsDirectory.vue';
import LocationsNYC from '@/components/Pages/Home Page/Locations/LocationsNYC.vue';
import LocationsNewJersey from '@/components/Pages/Home Page/Locations/LocationsNewJersey.vue';
import LocationsLasVegas from '@/components/Pages/Home Page/Locations/LocationsLasVegas.vue';
import LocationsLosAngeles from '@/components/Pages/Home Page/Locations/LocationsLosAngeles.vue';
import LocationsSaltLakeCity from '@/components/Pages/Home Page/Locations/LocationsSaltLakeCity.vue';

export default [
    {
        path: '',
        name: 'locationsDirectory',
        component: LocationsDirectory,
    },
    {
        path: 'new-york-city',
        name: 'locationsNYC',
        meta: {
            displayName: 'New York City',
            preRender: true,
        },
        component: LocationsNYC,
    },
    {
        path: 'chicago',
        name: 'locationsChicago',
        meta: {
            displayName: 'Chicago',
            preRender: true,
        },
        component: LocationsChicago,
    },
    {
        path: 'salt-lake-city',
        name: 'locationsSaltLakeCity',
        meta: {
            displayName: 'Salt Lake City',
            preRender: true,
        },
        component: LocationsSaltLakeCity,
    },
    {
        path: 'las-vegas',
        name: 'locationsLasVegas',
        meta: {
            displayName: 'Las Vegas',
            preRender: true,
        },
        component: LocationsLasVegas,
    },
    {
        path: 'new-jersey-metro-area',
        name: 'locationsNewJersey',
        meta: {
            displayName: 'New Jersey',
            preRender: true,
        },
        component: LocationsNewJersey,
    },
    {
        path: 'los-angeles-metro-area',
        name: 'locationsLosAngeles',
        meta: {
            displayName: 'Los Angeles',
            preRender: true,
        },
        component: LocationsLosAngeles,
    },
];
